import defaultClient from '@/plugins/axios/defaultClient'

export default {
  postFcm(data) {
    return defaultClient.post('/fcm', data)
  },
}
